import { useQuery } from 'react-query';
import { GetInvoicesArHealthResponse, GetInvoicesArHealthResponseSchema } from '@vy/api-definition';
import { queryKeys } from '../../../services/query-key/query-keys';
import { getPrivateApi } from '../../../services/api';
import { USE_CACHE_HEADER } from '../../../services/api/cache-headers';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useArHealthMetrics(options?: CustomUseQueryOptions<GetInvoicesArHealthResponse>) {
  return useQuery({
    queryKey: queryKeys.arHealthMetrics(),
    queryFn: async () => {
      const api = getPrivateApi();
      const response = await api.getInvoicesArHealth(USE_CACHE_HEADER);

      const parsedInvoicesArHealthResponse = GetInvoicesArHealthResponseSchema.parse(response);
      return parsedInvoicesArHealthResponse;
    },
    ...options,
  });
}
